import { BaseFilterField, FilterFieldType } from '@models/filters/base-filter-field';
import { matchFilter } from '@models/utils/strings';

export class DelaultFilterFieldDefault extends BaseFilterField<any, string, true> {
    id: string = 'default';
    type: FilterFieldType.String = FilterFieldType.String;
    single = true as const;

    constructor(private fns: string[], public name: string, public desc: string, hidden?: boolean) {
        super(hidden);
    }

    value(o: any): string {
        return o[this.fns[0]];
    }

    match(o: any, v?: string): boolean {
        if (!v) {
            return true;
        }
        for (const fn of this.fns) {
            if (matchFilter(o[fn], v)) {
                return true;
            }
        }
        return false;
    }

}
